export const admin = 'ROLE_ADMIN';
export const user = 'user';
export const sysadmin = 'SYSTEM_ADMIN';

export const KYC_VERIFICATION_MODE_ELECTRONIC = 'ELECTRONIC';

export const BANK_ACCOUNT_VERIFICATION_MODE_PENNY_DROP = 'PENNY_DROP';

export const SOURCE_DIGITAL = 'DIGITAL';

export const SOURCE_MANUAL = 'MANUAL';

export const LINK_TO_TYPE_PERSON = 'person';

export const USER_AGENT_WEB = 'web';

export const BUREAU_VERIFICATION_RULE_STRICT = 'STRICT';

export const BUREAU_VERIFICATION_RULE_LENIENT = 'LENIENT';

export const RULE_MANDATORY_COAPPLICANT_REQUIRED = 'COAPPLICANT-REQUIRED';

export const SETTING_DATAFORMAT_EMAIL_FORMAT = 'EMAIL_FORMAT';

export const SETTING_DATAFORMAT_MASKED_PHONE_NUMBER_FORMAT = 'MASKED_PHONE_NUMBER';

export const REQUEST_TYPE_APR = 'APR';

export const REQUEST_TYPE_INIT = 'INIT';

export const SETTING_DATAFORMAT_CREDIT_SCORE = 'CREDIT_SCORE_FORMAT';

export const KYC_VERIFICATION_MODE_IN_OFFICE = 'IN_OFFICE';

export const SETTINGS_IN_OFFICE_VERIFICATION = 'IN-OFFICE-VERIFICATION';

export const AUTHORITY_KYC_PLAIN_TEXT_DOC_NUM = 'KYC-PLAINTEXT-DOC-NUM-ENTRY';

export const OTHER_SELECT_OPTION = { code: 'OTH', name: 'Other' };
